import React from 'react';
import { base44 } from '@/api/base44Client';
import { useQuery } from '@tanstack/react-query';
import { Download, ExternalLink } from 'lucide-react';

export default function OrderDownloadsList({ orderId }) {
  const { data: downloads = [] } = useQuery({
    queryKey: ['order-downloads-customer', orderId],
    queryFn: () => base44.entities.OrderDownload.filter({ order_id: orderId }),
  });

  if (downloads.length === 0) return null;

  return (
    <div className="pt-4 border-t border-white/5">
      <p className="text-white/30 text-[10px] font-bold tracking-widest mb-3">DOWNLOADS</p>
      <div className="space-y-2">
        {downloads.map(d => (
          <a
            key={d.id}
            href={d.file_url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 bg-white/[0.02] border border-white/5 hover:border-primary/30 px-3 py-2.5 transition-colors group"
          >
            <Download className="w-3.5 h-3.5 text-primary shrink-0" />
            <span className="text-white/70 group-hover:text-white text-xs flex-1 transition-colors">{d.label}</span>
            <ExternalLink className="w-3 h-3 text-white/20 group-hover:text-primary transition-colors shrink-0" />
          </a>
        ))}
      </div>
    </div>
  );
}